function safeStr(x, d = '') {
  return typeof x === 'string' && x.trim() ? x.trim() : d;
}
function upper(x) {
  return safeStr(x, '').toUpperCase();
}
function toISO(x) {
  const s = safeStr(x, '');
  return s ? s.slice(0, 10) : null;
}

export function mapApiSessionsToGrid(apiSessions = []) {
  return (apiSessions || []).map((s) => {
    const participants = Array.isArray(s?.participants) ? s.participants : [];

    const members = participants
      .map(
        (p) =>
          safeStr(p?.memberNameSnapshot) ||
          safeStr(p?.fullName) ||
          safeStr(p?.memberName) ||
          'Misafir'
      )
      .filter(Boolean);

    // backend: participantCount var → onu öncele
    const booked = Number.isFinite(s?.participantCount)
      ? s.participantCount
      : Number.isFinite(s?.booked)
      ? s.booked
      : members.length;

    const cap = Number.isFinite(s?.capacity) ? s.capacity : Number.isFinite(s?.cap) ? s.cap : 1;

    const type = upper(s?.sessionType || s?.type) || 'NORMAL';
    const status = upper(s?.status || s?.sessionStatus);
    const billingMode = upper(s?.billingMode);

    const title =
      safeStr(s?.activityNameSnapshot) || safeStr(s?.activityName) || safeStr(s?.title) || 'Seans';

    // ✅ attendance türetme (UI tarafındaki filtreler için)
    // - attended true: en az 1 participant var ve hepsi ATTENDED ise
    // - attended false: CANCELLED/BURNED/ABSENT/NO_SHOW varsa
    // - attended null: hiç bilgi yok veya PENDING
    const attStates = participants.map((p) => upper(p?.attendanceStatus)).filter(Boolean);

    const derivedCancelled =
      status === 'CANCELLED' || attStates.includes('CANCELLED') || attStates.includes('CANCELED');

    const derivedAttended =
      typeof s?.attended !== 'undefined' && s?.attended !== null
        ? s.attended
        : attStates.length === 0
        ? null
        : attStates.every((x) => x === 'ATTENDED')
        ? true
        : attStates.some((x) =>
            ['ABSENT', 'NO_SHOW', 'NOSHOW', 'CANCELLED', 'CANCELED', 'BURNED'].includes(x)
          )
        ? false
        : null;

    return {
      id: String(s?.id),
      dayISO: toISO(s?.dayISO || s?.day || s?.date),
      startMin: Number.isFinite(s?.startMin) ? s.startMin : 0,
      dur: Number.isFinite(s?.durationMin) ? s.durationMin : Number.isFinite(s?.dur) ? s.dur : 60,

      type,
      status,
      billingMode,

      title,
      trainerId: s?.trainerId != null ? String(s.trainerId) : null,
      trainerName: safeStr(s?.trainerNameSnapshot) || safeStr(s?.trainerName) || '',

      cap,
      booked,

      members,
      participants,

      // ✅ EKLE
      note:
        safeStr(s?.note) ||
        safeStr(s?.sessionNote) ||
        safeStr(s?.notes) ||
        safeStr(s?.detailNote) ||
        null,

      attended: derivedAttended,
      cancelled: derivedCancelled,
    };
  });
}
